<template>
    <div class="a">
        <div class="b">
            <h1>登录</h1>
            <input type="number" placeholder="请输入手机号" v-model="phone">
            <div class="captcha">
            <input type="number" placeholder="请输入验证码" v-model="captcha">
            <div>获取验证码</div>
            </div>
        </div>
    </div>
</template>

<script>

export default{
    data(){
        return{
            phone:0,
            captcha:0
        }
    }
}
</script>

<style scoped>
.b{
    width: 70%;
    
}
</style>


// WEBPACK FOOTER //
// src/views/load.vue